/**
 * custom-tetra.js
 * -------------------------------------------------------
 * CUSTOM: Tetra image slider — product card multi-image carousel
 *
 * Source: layout/theme.liquid inline <script> block (~lines 339–465)
 *
 * Initialises on DOMContentLoaded; no-ops if no .tetra_image-slider
 * elements are present on the page.
 *
 * CUSTOM: MutationObserver re-runs initSlider for cards injected after
 * DOMContentLoaded (e.g. related products loaded async via product-recommendations).
 * -------------------------------------------------------
 */

function initTetraSlider(slider) {
  if (slider.dataset.tetraInitialised) return;
  slider.dataset.tetraInitialised = 'true';

  const track    = slider.querySelector('.tetra_slider-track');
  const slides   = slider.querySelectorAll('.tetra_slide');
  const dots     = slider.querySelectorAll('.tetra_dot');
  const leftBtn  = slider.querySelector('.tetra_arrow.left');
  const rightBtn = slider.querySelector('.tetra_arrow.right');

  let index         = 0;
  let isTransitioning = false;

  // Clone first slide for seamless loop
  const firstClone = slides[0].cloneNode(true);
  track.appendChild(firstClone);

  const totalSlides = slides.length;

  const updateSlider = (animate = true) => {
    const offset = -index * 100;
    track.style.transition = animate ? 'transform 0.4s ease' : 'none';
    track.style.transform  = `translateX(${offset}%)`;

    dots.forEach((dot, i) => dot.classList.toggle('active', i === index % totalSlides));
  };

  const nextSlide = () => {
    if (isTransitioning) return;
    index++;
    updateSlider();

    if (index === totalSlides) {
      isTransitioning = true;
      setTimeout(() => {
        index = 0;
        updateSlider(false);
        isTransitioning = false;
      }, 400);
    }
  };

  const prevSlide = () => {
    if (isTransitioning) return;

    if (index === 0) {
      track.style.transition = 'none';
      index = totalSlides;
      track.style.transform  = `translateX(${-index * 100}%)`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          index = totalSlides - 1;
          updateSlider();
        });
      });
    } else {
      index--;
      updateSlider();
    }
  };

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      if (isTransitioning || index === i) return;
      index = i;
      updateSlider();
    });
  });

  rightBtn?.addEventListener('click', (e) => { e.preventDefault(); nextSlide(); });
  leftBtn?.addEventListener('click',  (e) => { e.preventDefault(); prevSlide(); });

  // Swipe support
  let startX    = 0;
  let isDragging = false;

  slider.addEventListener('pointerdown',  (e) => { startX = e.clientX; isDragging = true; });
  slider.addEventListener('pointerup',    (e) => {
    if (!isDragging) return;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 50) diff > 0 ? prevSlide() : nextSlide();
    isDragging = false;
  });
  slider.addEventListener('pointerleave', () => { isDragging = false; });

  updateSlider(false); // initialise
}

document.addEventListener('DOMContentLoaded', function () {
  // CUSTOM: Open description accordion by default on product page (matches live theme behaviour)
  if (document.body.classList.contains('template--product-yonder-dev')) {
    const descAccordion = Array.from(document.querySelectorAll('accordion-disclosure')).find((el) => {
      const toggle = el.querySelector('.accordion__toggle');
      return toggle && toggle.textContent.trim().toLowerCase().startsWith('description');
    });
    if (descAccordion) {
      const details = descAccordion.querySelector('details');
      if (details && !details.open) {
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }
    }
  }

  // Strip trailing .00 from on-sale badge amounts (e.g. "Save $26.00" → "Save $26")
  document.querySelectorAll('.badge--on-sale').forEach((badge) => {
    badge.innerHTML = badge.innerHTML.replace(/\.00(?=\s|<|&|$)/g, '');
  });

  document.querySelectorAll('.tetra_image-slider').forEach(initTetraSlider);

  // CUSTOM: Watch for sliders injected after page load (related products are async)
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.tetra_image-slider')) {
          initTetraSlider(node);
        } else {
          node.querySelectorAll('.tetra_image-slider').forEach(initTetraSlider);
        }
        // Strip .00 from any sale badges in newly injected cards (e.g. async related products)
        if (node.matches('.badge--on-sale')) {
          node.innerHTML = node.innerHTML.replace(/\.00(?=\s|<|&|$)/g, '');
        } else {
          node.querySelectorAll('.badge--on-sale').forEach((badge) => {
            badge.innerHTML = badge.innerHTML.replace(/\.00(?=\s|<|&|$)/g, '');
          });
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
});
